export const problems = [
  {
    patientId: "10",
    module: "problems",
    pageTitle: "Problems",

    subnav: [
      { sectionId: "problem-list-history", label: "Problem List & History" },
      { sectionId: "allergy-history", label: "Allergy History" },
      { sectionId: "past-surgical-history", label: "Past Surgical History" },
      { sectionId: "family-history", label: "Family History" },
      { sectionId: "social-history", label: "Social History" },
      { sectionId: "impairments-history", label: "Impairments History" },
      { sectionId: "health-maintenance", label: "Health Maintenance" },
      { sectionId: "travel-history", label: "Travel History" },
      {
        sectionId: "pregnancy-birth-history",
        label: "Pregnancy & Birth History",
      },
      { sectionId: "other-past-history", label: "Other Past History" },
    ],

    sections: [
      // ✅ Problem List & History (8 rows)
      {
        id: "problem-list-history",
        title: "Problem List & History",
        tables: [
          {
            id: "problems-main",
            columns: [
              { key: "dxTitle", header: "Dx Title", sortable: true },
              { key: "icd9Code", header: "ICD9" },
              { key: "icd10Code", header: "ICD10" },
              { key: "dxStory", header: "Dx Story" },
            ],
            rows: [
              {
                dxTitle: "S/P lumbar fusion",
                icd9Code: "V45.4",
                icd10Code: "—",
                dxStory: "—",
              },
              {
                dxTitle:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                icd9Code: "724.2",
                icd10Code: "M54.5",
                dxStory: "—",
              },
              {
                dxTitle: "Low back pain, episodic",
                icd9Code: "724.2",
                icd10Code: "M54.5",
                dxStory: "—",
              },
              {
                dxTitle: "Left hip pain",
                icd9Code: "719.45",
                icd10Code: "M25.559",
                dxStory: "—",
              },
              {
                dxTitle: "Hypertension",
                icd9Code: "—",
                icd10Code: "—",
                dxStory: "—",
              },
              {
                dxTitle: "Hyperlipidemia",
                icd9Code: "272.4",
                icd10Code: "E78.5",
                dxStory: "—",
              },
              {
                dxTitle: "HTN (hypertension)",
                icd9Code: "401.9",
                icd10Code: "I10.",
                dxStory: "—",
              },
              {
                dxTitle: "Back Injury",
                icd9Code: "—",
                icd10Code: "—",
                dxStory: "—",
              },
            ],
            ui: {
              searchable: true,
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1deixV85GUOCL27kOHdGxcIStUCgm0vqu",
                pdf: "https://drive.google.com/uc?export=download&id=1KgE9e-0zo8gAhfk8mT9qJI5VC2Gcnj3j",
                xls: "https://docs.google.com/spreadsheets/d/1s-TT3N0nDzLw2Sl97AdRmISRyzfp2ZQw/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
            },
          },
        ],
      },

      // ✅ Allergy History (1 row)
      {
        id: "allergy-history",
        title: "Allergy History",
        tables: [
          {
            id: "allergy-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "resolvedDate", header: "Resolved Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "No Known Drug Allergies",
                dxCode: "—",
                onsetDate: "02/15/2017",
                resolvedDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      // ✅ Past Surgical History (4 rows)
      {
        id: "past-surgical-history",
        title: "Past Surgical History",
        tables: [
          {
            id: "past-surgical-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "brain",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Adenoidectomy",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Tonsillectomy",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Spinal Fusion - Lower Back",
                dxCode: "—",
                onsetDate: "—",
                comments: "08/31/2017",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      // ✅ Family History (1 row)
      {
        id: "family-history",
        title: "Family History",
        tables: [
          {
            id: "family-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "No pertinent family history",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      // ✅ Social History (2 rows)
      {
        id: "social-history",
        title: "Social History",
        tables: [
          {
            id: "social-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Marital status",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "Married",
                status: "Active",
              },
              {
                dxTitle: "Former Smoker",
                dxCode: "—",
                onsetDate: "—",
                comments: "10yrs ago",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      // ✅ Impairments History (10 rows)
      {
        id: "impairments-history",
        title: "Impairments History",
        tables: [
          {
            id: "impairments-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Gait",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "benign brain tumor",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Balance",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Recreational activities",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "walking",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Home maintenance",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Transfers",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Bed mobility",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Walking in community",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Standing",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Lifting",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Carrying",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      // (остальные секции можешь оставить пустыми/плейсхолдерами пока нет данных)
      { id: "health-maintenance", title: "Health Maintenance", tables: [] },
      { id: "travel-history", title: "Travel History", tables: [] },
      {
        id: "pregnancy-birth-history",
        title: "Pregnancy & Birth History",
        tables: [],
      },
      { id: "other-past-history", title: "Other Past History", tables: [] },
    ],
  },

  {
    patientId: "11",
    module: "problems",
    pageTitle: "Problems",

    subnav: [
      { sectionId: "problem-list-history", label: "Problem List & History" },
      { sectionId: "allergy-history", label: "Allergy History" },
      { sectionId: "past-surgical-history", label: "Past Surgical History" },
      { sectionId: "family-history", label: "Family History" },
      { sectionId: "social-history", label: "Social History" },
      { sectionId: "impairments-history", label: "Impairments History" },
      { sectionId: "health-maintenance", label: "Health Maintenance" },
      { sectionId: "travel-history", label: "Travel History" },
      {
        sectionId: "pregnancy-birth-history",
        label: "Pregnancy & Birth History",
      },
      { sectionId: "other-past-history", label: "Other Past History" },
    ],

    sections: [
      {
        id: "problem-list-history",
        title: "Problem List & History",
        tables: [
          {
            id: "problems-main",
            columns: [
              { key: "dxTitle", header: "Dx Title", sortable: true },
              { key: "icd9Code", header: "ICD9" },
              { key: "icd10Code", header: "ICD10" },
              { key: "dxStory", header: "Dx Story" },
            ],
            rows: [
              {
                dxTitle: "S/P lumbar fusion",
                icd9Code: "V45.4",
                icd10Code: "—",
                dxStory: "—",
              },
              {
                dxTitle:
                  "Low back pain, unspecified back pain laterality, unspecified chronicity, with sciatica presence unspecified",
                icd9Code: "724.2",
                icd10Code: "M54.5",
                dxStory: "—",
              },
              {
                dxTitle: "Low back pain, episodic",
                icd9Code: "724.2",
                icd10Code: "M54.5",
                dxStory: "—",
              },
              {
                dxTitle: "Left hip pain",
                icd9Code: "719.45",
                icd10Code: "M25.559",
                dxStory: "—",
              },
              {
                dxTitle: "Hypertension",
                icd9Code: "—",
                icd10Code: "—",
                dxStory: "—",
              },
              {
                dxTitle: "Hyperlipidemia",
                icd9Code: "272.4",
                icd10Code: "E78.5",
                dxStory: "—",
              },
              {
                dxTitle: "HTN (hypertension)",
                icd9Code: "401.9",
                icd10Code: "I10.",
                dxStory: "—",
              },
              {
                dxTitle: "Back Injury",
                icd9Code: "—",
                icd10Code: "—",
                dxStory: "—",
              },
            ],
            ui: {
              searchable: true,
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1deixV85GUOCL27kOHdGxcIStUCgm0vqu",
                pdf: "https://drive.google.com/uc?export=download&id=1KgE9e-0zo8gAhfk8mT9qJI5VC2Gcnj3j",
                xls: "https://docs.google.com/spreadsheets/d/1s-TT3N0nDzLw2Sl97AdRmISRyzfp2ZQw/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
            },
          },
        ],
      },
      {
        id: "allergy-history",
        title: "Allergy History",
        tables: [
          {
            id: "allergy-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "resolvedDate", header: "Resolved Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "No Known Drug Allergies",
                dxCode: "—",
                onsetDate: "02/15/2017",
                resolvedDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "past-surgical-history",
        title: "Past Surgical History",
        tables: [
          {
            id: "past-surgical-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "brain",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Adenoidectomy",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Tonsillectomy",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Spinal Fusion - Lower Back",
                dxCode: "—",
                onsetDate: "—",
                comments: "08/31/2017",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "family-history",
        title: "Family History",
        tables: [
          {
            id: "family-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "No pertinent family history",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "social-history",
        title: "Social History",
        tables: [
          {
            id: "social-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Marital status",
                dxCode: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "Married",
                status: "Active",
              },
              {
                dxTitle: "Former Smoker",
                dxCode: "—",
                onsetDate: "—",
                comments: "10yrs ago",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },
      {
        id: "impairments-history",
        title: "Impairments History",
        tables: [
          {
            id: "impairments-history-table",
            columns: [
              { key: "dxTitle", header: "Dx Title" },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Gait",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "benign brain tumor",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Balance",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Recreational activities",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "walking",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Home maintenance",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Transfers",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Bed mobility",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Walking in community",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Standing",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Lifting",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
              {
                dxTitle: "Carrying",
                dxCode: "—",
                dxStory: "—",
                onsetDate: "—",
                comments: "—",
                attributes: "—",
                status: "Active",
              },
            ],
            ui: { searchable: true, defaultRowsPerPage: 10 },
          },
        ],
      },

      { id: "health-maintenance", title: "Health Maintenance", tables: [] },
      { id: "travel-history", title: "Travel History", tables: [] },
      {
        id: "pregnancy-birth-history",
        title: "Pregnancy & Birth History",
        tables: [],
      },
      { id: "other-past-history", title: "Other Past History", tables: [] },
    ],
  },
];
